export const PATHS = {
  MI_DISPATCH: "/dispatch",
  MI_SCHEDULING: "/scheduling",
  MI_ACCOUNTING: "/accounting",
  MI_INSPECTIONS: "/inspections",
  MI_ESTIMATING: "/estimating",
  SETTINGS: "/settings",
  HOMES: "/homes",
  COMMUNITIES: "/communities",
  CUSTOMERS: "/accounting/customers",
  VENDORS: "/accounting/vendors",
  CONFIG: "/config",
};
